<nn-graph type='undirected'></nn-graph>